import { fromLocalInput, toLocalInput } from '@/lib/format';

/** Valor por defecto de «¿Cuándo ocurrió?»: ahora, en la hora de la zona de la empresa (formato de `datetime-local`). */
export function occurredAtNow(tz?: string): string {
  return toLocalInput(new Date(), tz);
}

/** Instante a enviar a la API (`completedAt` / `visitAt`) a partir del valor del campo, leído en la zona de la empresa. */
export function occurredAtToDate(value: string, tz?: string): Date {
  return new Date(fromLocalInput(value, tz));
}
